// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { Analytics, tracingCallback } from '@trello/atlassian-analytics';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { getKey, Key } from '@trello/keybindings';

import { isOverLimit } from 'app/scripts/lib/limits';
import { maybeDisplayLimitsErrorOnCardAdd } from 'app/scripts/views/card/CardLimitsError';
import { View } from 'app/scripts/views/internal/View';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { ListCopyTemplate } from 'app/scripts/views/templates/ListCopyTemplate';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

interface ListCopyView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listenTo: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
}

class ListCopyView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'copy list';
    this.prototype.tagName = 'form';

    this.prototype.events = {
      // @ts-expect-error
      'click .js-submit': 'submit',
      submit: 'submit',
      'keydown textarea[name="name"]': 'keydownEvent',
    };
  }

  initialize() {
    Analytics.sendScreenEvent({
      name: 'copyListInlineDialog',
      containers: {
        list: {
          id: this.model.id,
        },
        board: {
          id: this.model.getBoard()?.id,
        },
        organization: {
          id: this.model.getBoard()?.getOrganization()?.id,
        },
      },
    });

    return this.listenTo(this.model.getBoard(), 'change:limits', this.render);
  }

  render() {
    const board = this.model.getBoard();
    this.$el.html(
      ListCopyTemplate({
        canCopyTotal: !isOverLimit(
          'lists',
          'totalPerBoard',
          board.get('limits'),
        ),
        canCopyOpen: !isOverLimit('lists', 'openPerBoard', board.get('limits')),
        name: this.model.get('name'),
      }),
    );

    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  keydownEvent(e: any) {
    if (getKey(e) === Key.Enter) {
      stopPropagationAndPreventDefault(e);
      this.submit(e);
      return;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  submit(e: any) {
    stopPropagationAndPreventDefault(e);
    const nameInput = this.getListName();

    // return if the user hasn't entered a title
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    if (nameInput.val().trim() === '') {
      nameInput.focus().select();
      return;
    }

    const board = this.model.getBoard();
    const exceedsLimit =
      isOverLimit('lists', 'totalPerBoard', board.get('limits')) ||
      isOverLimit('lists', 'openPerBoard', board.get('limits'));
    $('.js-limit-exceeded', this.$el).toggleClass('hide', !exceedsLimit);
    if (exceedsLimit) {
      return;
    }

    if (this.model.cardList.length > 0) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      let hasChecklists: any;
      let hasAttachments = (hasChecklists = false);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.model.cardList.forEach(function (card: any) {
        hasAttachments = hasAttachments || card.attachmentList.length > 0;
        return (hasChecklists = hasChecklists || card.checklistList.length > 0);
      });

      const options = {
        $elem: $(e.target, this.$el),
        hasChecklists,
        hasAttachments,
        destinationBoard: board,
      };
      if (maybeDisplayLimitsErrorOnCardAdd(options)) {
        return;
      }
    }

    const listPos = board.listList.calcPos(
      this.model.getIndexInList() + 1,
      this.model,
      true,
    );

    const newListParams = {
      idListSource: this.model.id,
      idBoard: this.model.get('idBoard'),
      pos: listPos,
      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      name: nameInput.val().trim(),
      closed: false,
    };

    const taskName = 'create-list/copy';
    const source = 'copyListInlineDialog';
    const listSourceId = this.model.id || '';

    const traceId = Analytics.startTask({
      // @ts-expect-error TS(2322): Type '"create-list/copy"' is not assignable to typ... Remove this comment to see the full error message
      taskName,
      source,
    });

    const newList = board.listList.createWithTracing(
      newListParams,
      { modelCache: this.modelCache, traceId },
      tracingCallback(
        {
          // @ts-expect-error TS(2322): Type '"create-list/copy"' is not assignable to typ... Remove this comment to see the full error message
          taskName,
          traceId,
          source,
          attributes: {
            listSourceId,
            // @ts-expect-error TS(2322): Type '{ list: { id: any; }; board: { id: any; }; o... Remove this comment to see the full error message
            context: {
              list: {
                id: listSourceId,
              },
              board: {
                id: this.model.getBoard()?.id || '',
              },
              organization: {
                id: this.model.getBoard()?.getOrganization()?.id || '',
              },
            },
          },
        },
        (err, list) => {
          if (err) {
            board.listList.remove(newList);
          } else {
            Analytics.sendTrackEvent({
              action: 'copied',
              actionSubject: 'list',
              source: source,
              attributes: {
                listSourceId,
              },
              containers: {
                board: {
                  id: this.model.getBoard()?.id || '',
                },
                list: {
                  id: newList?.id || '',
                },
                organization: {
                  id: this.model.getBoard()?.getOrganization()?.id || '',
                },
              },
            });
          }
        },
      ),
    );

    PopOver.hide();
  }

  getListName() {
    return $('textarea[name="name"]', this.$el);
  }
}

ListCopyView.initClass();
export { ListCopyView };
